<textarea
    ng-auto-expand
    [(ngModel)]="value"
    (ngModelChange)="valueChange.emit(value)"
    placeholder="{{ placeholder }}"
    maxlength="{{ maxLength }}"
></textarea>
